import { render, staticRenderFns } from "./IndagineEpidemiologicaLeishmaniosiVisceraleEditComponent.vue?vue&type=template&id=292c1f80"
import script from "./IndagineEpidemiologicaLeishmaniosiVisceraleEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaLeishmaniosiVisceraleEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports